import { type FunctionComponent } from 'react';
import FergusonIsotypeIcon from '../../svgs/ferguson-isotype.svg';

export const ShowroomOnlyBadge: FunctionComponent<{}> = () => {
	return (
		<section className="inline-flex flex-row items-center mv1 mv0-ns pa1 bg-theme-ferguson-blue">
			<FergusonIsotypeIcon className="f6 theme-white" />
			<span className="theme-white f6 ttu fw6 ml1">Ferguson Showroom Only</span>
		</section>
	);
};
